import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { BroadcastChannelContext, SessionChangedMessage } from "contexts/BroadcastChannelContext";
import { useContext, useEffect, useState } from "react";

const SessionChanged = () => {
  const broadcastChannelMap = useContext(BroadcastChannelContext);
  const [showDialog, setShowDialog] = useState(false);
  const [sessionTitle, setSessionTitle] = useState("Session Closed");
  const [sessionContent, setSessionContent] = useState(
    "Your session has been closed in another tab. Please refresh the page to log back in."
  );
  const [showHomeAction, setShowHomeAction] = useState(false);

  useEffect(() => {
    const sessionChannel = broadcastChannelMap?.session;

    if (sessionChannel !== undefined) {
      sessionChannel.onmessage = (event) => {
        if (event.data !== undefined) {
          if (event.data === SessionChangedMessage.LOGGED_IN) {
            setSessionTitle("Session Changed");
            setSessionContent("You logged in another tab.");
            setShowHomeAction(true);
            setShowDialog(true);
          } else if (event.data === SessionChangedMessage.LOGGED_OUT) {
            setShowDialog(true);
          }
        }
      };
    }
  }, [broadcastChannelMap.session]);

  return (
    <>
      {showDialog && (
        <Dialog open={showDialog}>
          <DialogTitle>{sessionTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText>{sessionContent}</DialogContentText>
          </DialogContent>
          {showHomeAction && (
            <DialogActions>
              <Button href="/lens">Back to home</Button>
            </DialogActions>
          )}
        </Dialog>
      )}
    </>
  );
};

export default SessionChanged;
